<script>
import TwContainer from '@/components/generic/tw-container.vue'
import TwCard from '@/components/generic/tw-card.vue'
import TwButton from '@/components/generic/tw-button.vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import fundraiserPublicFetchMixin from '@/mixins/fundraiserPublicFetchMixin.js'
import TwTransitionContainer from '@/components/generic/tw-transition-container.vue'
import fundraiserDonateMixin from '@/mixins/fundraiserDonateMixin.js'
import DonateAmountField from '@/components/donations/public/donate-amount-field.vue'
import TwCheckbox from '@/components/generic/forms/tw-checkbox.vue'
import TwValidationErrors from '@/components/generic/tw-validation-errors.vue'
import TwInput from '@/components/generic/forms/tw-input.vue'
import TwTextarea from '@/components/generic/forms/tw-textarea.vue'
import TwTransitionListContainer from '@/components/generic/tw-transition-list-container.vue'
import TwProgressBar from '@/components/generic/tw-progress-bar.vue'
import FundraiserDonationAppFeeCard from '@/components/fundraisers/public/fundraiser-donation-app-fee-card.vue'
import TwTimeLeft from '@/components/generic/tw-time-left.vue'
import { XMarkIcon } from '@heroicons/vue/24/outline'

export default {
  name: 'FundraiserDonatePage',
  components: { TwTimeLeft, FundraiserDonationAppFeeCard, TwProgressBar, TwTransitionListContainer, TwTextarea, TwInput, TwValidationErrors, TwCheckbox, DonateAmountField, TwTransitionContainer, FontAwesomeIcon, TwButton, TwCard, TwContainer, XMarkIcon },
  mixins:[fundraiserPublicFetchMixin, fundraiserDonateMixin],
  async mounted() {
    await this.fetchFundraiser()
    if(this.fundraiser && this.fundraiser.settings && this.fundraiser.settings.force_donating_to_fundraiser_pages_only) {
      this.$notify('Please select a supporter you want to donate to first', 'warning')
      this.$router.push({ name: 'FundraiserPublicPage', params: { fundraiserId: this.fundraiser.id, slug: this.fundraiser.slug } })
    }
  },
  data() {
    return {
      DonationPublicMessage: false
    };
  }

}
</script>

<template>
  <tw-transition-container>
    <div v-if="fundraiser" class="h-100">
      <div v-if="fundraiser" class="w-full bg-cover bg-center bg-no-repeat fixed h-screen bg-overlay z-0" :style="`background-image: url('${fundraiser.cover_image_url}');`" />
        <div class="z-10 flex justify-center sm:p-6 relative z-1">
          <tw-transition-list-container>
            <div class="w-full sm:max-w-lg">
              <div v-if="fundraiser" class="rounded-none sm:rounded-2xl bg-white shadow-sm relative p-6 md:p-8 min-h-screen sm:min-h-max">
                <tw-button variant="link" class="absolute right-4 top-4" :to="{ name: 'FundraiserPublicPage', params: { fundraiserId: fundraiser.id, slug: fundraiser.slug} }">
                  <XMarkIcon class="size-7" />
                </tw-button>
                <div class="flex gap-2 flex-col text-center mt-6 mb-4">
                  <h2 class="text-xl md:text-2xl">
                    {{ fundraiser.title }}
                  </h2>
                  <div> by <span>{{ fundraiser.cached.beneficiary_name }}</span> </div>
                  <!-- <div class="my-4">
                    <h5 v-if="fundraiser.cached.remaining > 0">
                      ${{ fundraiser.cached.remaining_formatted }} remaining to go
                    </h5>
                    <tw-progress-bar v-if="fundraiser.cached.percentage_raised && fundraiser.cached.percentage_raised > 0" class="mt-3 mb-2" :progress="fundraiser.cached.percentage_raised" />
                    <tw-time-left v-if="fundraiser.deadline" class="text-sm text-gray-600" :deadline="fundraiser.deadline" detailed />
                  </div> -->
                </div>
                <div v-if="!DonationCompleted">
                  <div>
                    <!-- <h5 class="text-center mt-5">
                      Amount to Give:
                    </h5> -->
                    <div v-if="!DonationGatewayActive && !DonationCompleted">
                      <donate-amount-field ref="donationField" v-model="DonationAmount" size="lg" />
                      <div v-if="fundraiser.cached.donation_highest_amount > 0" class="mt-6 text-center text-sm bg-gray-50 p-4 rounded-lg">
                        A donation of <span class="text-amber-500 underline cursor-pointer" @click="DonationAmount = fundraiser.cached.donation_highest_amount + 1">${{ fundraiser.cached.donation_highest_amount }} or more</span> would make you the top giver so far.
                      </div>
                      <div class="flex flex-col gap-2">
                        <tw-input v-model="DonationName" required class="mt-4 mb-1" label="Name" placeholder="Enter your name" />
                        <tw-checkbox v-model="DonationAnonymousName">
                          Keep my name hidden from public view
                        </tw-checkbox>
                        <tw-checkbox v-model="DonationAnonymousAmount">
                          Keep my amount hidden from public view
                        </tw-checkbox>
                        <tw-checkbox v-model="DonationPublicMessage">
                          Leave a public message
                        </tw-checkbox>
                        <div v-if="DonationPublicMessage" class="mt-1">
                          <tw-textarea v-model="DonationComment"  class="w-full" rows="3" placeholder="Enter your message" />
                        </div>
                      </div>
                      <fundraiser-donation-app-fee-card :donation-amount="DonationAmount" v-model="DonationAppFeeAmount" class="mt-5 mb-3" />
                      <div class="mt-8 flex justify-between items-center">
                        <div class="form-label mb-0">
                          Donation Total:
                        </div>
                        <div class="text-right font-sans font-semibold">
                          ${{ donationTotalAmount }}
                        </div>
                      </div>
                      <div class="mt-3">
                        <tw-button block variant="amber" size="lg" :disabled="donateButtonDisabled" @click="startDonation">
                          Continue
                        </tw-button>
                      </div>
                    </div>
                  </div>
                </div>
                <tw-validation-errors :validation-result-error="ValidationErrorMessage" />
                <tw-transition-list-container>
                  <div v-if="DonationGatewayActive" id="checkout" />
                  <!-- TODO: Should this be a back button? It takes the user back to the previous step but then the continue button does not work after that. This seams like a glitch?
                  <tw-button v-if="DonationGatewayActive" class="mt-2" size="lg" block variant="secondary" @click="cancelDonation">
                    Cancel
                  </tw-button> -->
                </tw-transition-list-container>
                <div class="mt-4 text-xs text-center">
                  <i class="pi pi-lock mr-1" />Your donation is safe and secure. All proceeds of your donation will go directly to <strong>{{ fundraiser.cached.beneficiary_name }}</strong>.
                </div>
              </div>
            </div>
          </tw-transition-list-container>
        </div>
    </div>
  </tw-transition-container>
</template>

<style scoped>

</style>
